import { onBeforeUnmount, onMounted } from "vue";

export function useCommandShortcut(callback) {
  const onKeydown = (event) => {
    if (event.repeat) return;
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault();
      callback(event);
    }
  };

  onMounted(() => window.addEventListener("keydown", onKeydown));
  onBeforeUnmount(() => window.removeEventListener("keydown", onKeydown));
}
